import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  GamificationAchievement,
  GamificationCatalog,
  GamificationLedgerPage,
  GamificationPurchaseInput,
  GamificationPurchaseResponse,
  GamificationSettings,
  GamificationSettingsInput,
  GamificationSummary,
} from "~/types/gamification";

export default class GamificationModule extends HttpFactory {
  getSummary() {
    return this.get<GamificationSummary>(ENDPOINTS.GAMIFICATION.ME);
  }

  checkIn() {
    return this.post<GamificationSummary>(ENDPOINTS.GAMIFICATION.CHECK_IN, {});
  }

  getCatalog() {
    return this.get<GamificationCatalog>(ENDPOINTS.GAMIFICATION.CATALOG);
  }

  getAchievements() {
    return this.get<GamificationAchievement[]>(
      ENDPOINTS.GAMIFICATION.ACHIEVEMENTS,
    );
  }

  getLedger(page = 1) {
    return this.get<GamificationLedgerPage>(ENDPOINTS.GAMIFICATION.LEDGER, {
      page,
    });
  }

  purchase(input: GamificationPurchaseInput) {
    return this.post<GamificationPurchaseResponse>(
      ENDPOINTS.GAMIFICATION.PURCHASES,
      input,
    );
  }

  equipCursor(itemCode: string | null) {
    return this.post<GamificationSummary>(
      ENDPOINTS.GAMIFICATION.EQUIPPED_CURSOR,
      {
        item_code: itemCode,
      },
    );
  }

  getSchoolSettings() {
    return this.forWorkspace("school").get<GamificationSettings>(
      ENDPOINTS.GAMIFICATION.SCHOOL_SETTINGS,
    );
  }

  updateSchoolSettings(input: GamificationSettingsInput) {
    return this.forWorkspace("school").patch<GamificationSettings>(
      ENDPOINTS.GAMIFICATION.SCHOOL_SETTINGS,
      input,
    );
  }
}
